<template>
  <div class="sections-container">
    <div class="header-sections">
    <span class="title-section">Cortes de caja</span>

    <div class="filter-colum-sections">

      <v-text-field
        style="width: 320px; visibility: hidden;"
        type="text"
        placeholder="Buscar"
        v-model="currentSearch"
        color="#222222"
        variant="underlined">
        <template v-slot:append-inner>
          <v-icon color="#222222" icon="mdi-magnify" size="small"/>
        </template>
      </v-text-field>

    </div>
  </div>
  <div class="select-filter-container">
    <div>

      <span class="title-filter">De </span>
      <!--Aqui quiero poner el date picker-->
      <v-dialog v-model="showPS" max-width="330">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props"
          color="#FF5700"
          variant="text">
            {{dateStartFormatted}}
          </v-btn>
        </template>
        <v-card>
          <v-date-picker
            v-model="dateStart"
            type="date"
            :allowed-dates="allowedPastDates"
            hide-header
            hide-actions
            locale="es"
            @update:model-value="onDateStartSelected"/>
        </v-card>
      </v-dialog>
      <!--End Date-->
      <span class="title-filter"> a </span>
      <!--Aqui quiero poner el date picker-->
      <v-dialog v-model="showPE" max-width="330">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props"
          color="#FF5700"
          variant="text">
            {{dateEndFormatted}}
          </v-btn>
        </template>
        <v-card>
          <v-date-picker
            v-model="dateEnd"
            type="date"
            :allowed-dates="allowedPastDates"
            hide-header
            hide-actions
            locale="es"
            @update:model-value="onDateEndSelected"/>
        </v-card>
      </v-dialog>
      <!--End Date-->
    </div>
    <div class="autocomplete-container">
      <span class="title-filter">POS:</span>
      <v-select
        v-model="filterSelected"
        :items="filterData"
        item-title="label"
        item-value="value"
        density="compact"
        hide-details="auto"
        variant="solo"
        class="no-bg"/>
    </div>
  </div>

  <CutsTable
    :cuts="cuts"/>

</div>
</template>
<script>
import cutsApi from '@/api/cutsApi'
import terminalsApi from '@/api/terminalsApi'
import dateTransform from '@/utils/dateTransform'
import CutsTable from '../tables/CutsTable.vue'
export default {
  name: 'CommerciaVueCuts',
  components: {
    CutsTable
  },
  data () {
    return {
      dateStart: new Date(),
      showPS: false,
      dateEnd: new Date(),
      showPE: false,

      business: this.$store.getters.business,
      currentSearch: '',
      filterSelected: 'Todos',
      filterData: [{ value: 'Todos', label: 'Todos' }],

      cuts: [],
      page: 1,
      totalPages: 0
    }
  },
  computed: {
    busines () {
      return this.$store.getters.business
    },
    dateStartFormatted () {
      return dateTransform.formatInput(this.dateStart)
    },
    dateEndFormatted () {
      return dateTransform.formatInput(this.dateEnd)
    },
    user () {
      return this.$store.getters.user
    }
  },
  created () {
    if (this.user?.role === 'finance') {
      this.$router.push({ name: 'dashboard' })
    }
    this.page = 1
    this.getPos()
    this.getList()
  },
  watch: {
    currentSearch (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    filterSelected (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    dateStart (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    dateEnd (newVal, oldVal) {
      this.page = 1
      this.getList()
    }
  },
  methods: {
    moreData () {
      this.page += 1
      this.getList()
    },
    clearSearch () {
      this.currentSearch = ''
      this.page = 1
      this.getList()
    },
    async getPos () {
      const listPos = await terminalsApi.list(this.business._id, '')
      for (const item of listPos) {
        this.filterData.push({ value: item._id, label: item.name })
      }
    },
    async getList () {
      if (this.filterSelected === 'Todos') {
        const dataResponse = await cutsApi.listByBussines(
          this.business._id,
          this.page,
          dateTransform.startTimestamp(this.dateStart),
          dateTransform.endTimestamp(this.dateEnd),
          20)
        this.cuts = this.page === 1
          ? (dataResponse.data || [])
          : [...this.cuts, ...(dataResponse.data || [])]
        this.totalPages = dataResponse.totalPages || 0
      } else {
        const dataResponse = await cutsApi.listByPos(
          this.filterSelected,
          this.page,
          dateTransform.startTimestamp(this.dateStart),
          dateTransform.endTimestamp(this.dateEnd),
          20)
        this.orders = this.page === 1
          ? (dataResponse.data || [])
          : [...this.orders, ...(dataResponse.data || [])]
        this.totalPages = dataResponse.totalPages || 0
      }
    },
    onDateStartSelected (newDate) {
      this.dateStart = newDate
      this.showPS = false
    },
    onDateEndSelected (newDate) {
      this.dateEnd = newDate
      this.showPE = false
    }
  }
}
</script>

<style scoped>
@import '@/assets/styles/sections.css';
@import '@/assets/styles/inputs.css';
</style>
